module.exports = __webpack_public_path__ + "img/icon_guang1.f00e038c.png";